import React, { useState } from 'react'
import {
    Paper,
    FormControl,
    TextField,
    Grid,
    Button,
    InputLabel,
    Label,
    Select,
    MenuItem,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(3),
    },
    selectList: {
        height: 40,
    },
    loadingSection: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '300px',
        width: '100%',
    },
}))

const Search = () => {
    const classes = useStyles()
    const [searchForm, setSearchForm] = useState({})
    // const [isLoadingData, setIsLoadingData] = useState(true)

    // useEffect(() => {
    //     const managedService = userService.getManagedService()

    //     ;(async function getServiceAsync() {
    //         try {
    //             await serviceService
    //                 .getService(managedService.id)
    //                 .then(result => {
    //                     setServiceDetails(result)
    //                     setIsLoadingData(false)
    //                 })
    //         } catch (exception) {
    //             console.log(exception)
    //         }
    //     })()
    // }, [])

    return (
        <>
            <Paper className={classes.paper}>
                <Grid
                    container
                    direction='row'
                    justify='flex-start'
                    alignItems='flex-start'
                    spacing={3}>
                    <Grid item xs={4}>
                        <FormControl className={classes.formControl}>
                            <InputLabel>User Valid</InputLabel>
                            <Select value={'1'} onChange={e => {}}>
                                <MenuItem value={1}>{'Yes'}</MenuItem>
                                <MenuItem value={2}>{'No'}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                        <FormControl className={classes.formControl}>
                            <InputLabel>User Role</InputLabel>
                            <Select value={'1'} onChange={e => {}}>
                                <MenuItem value={1}>{'All'}</MenuItem>
                                <MenuItem value={2}>{'Hr User'}</MenuItem>
                                <MenuItem value={3}>{'Business User'}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                        <FormControl className={classes.formControl}>
                            <InputLabel>AccessLevel</InputLabel>
                            <Select value={'1'} onChange={e => {}}>
                                <MenuItem value={1}>{'All'}</MenuItem>
                                <MenuItem value={2}>{'Active'}</MenuItem>
                                <MenuItem value={3}>{'Demo'}</MenuItem>
                                <MenuItem value={4}>{'Live'}</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid
                    container
                    direction='row'
                    justify='flex-start'
                    alignItems='flex-start'
                    spacing={3}>
                    <Grid item xs={4}>
                        <FormControl>
                            <TextField label={'Name'} value={searchForm.name} />
                        </FormControl>
                    </Grid>

                    <Grid
                        container
                        item
                        xs={12}
                        direction='row'
                        justify='flex-start'>
                        <Button variant='contained' color='secondary'>
                            Search
                        </Button>
                        <Button variant='contained' color='secondary'>
                            Reset
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
        </>
    )
}

export default Search
